class BaoProductRecommendations extends HTMLElement {
  constructor () {
    super()

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      let apiUrl = this.dataset.url

      if (apiUrl.includes('product_id=&')) {
        const productId = apiUrl.match(/product_id=([a-z0-9-]+)/)
        if (!productId) {
          const wishlist = JSON.parse(localStorage.getItem('fostrWishlist'))
          const wishlistProductID = wishlist.products[wishlist.products.length - 1].id
          if (wishlistProductID) {
            apiUrl = apiUrl.replace('product_id=', `product_id=${wishlistProductID}`)
          }
        }
      }

      // Stop if there is no product
      if (apiUrl.includes('product_id=&')) return
      fetch(apiUrl)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('bao-product-recommendations')
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }
        })
        .catch(e => {
          console.error(e)
        })
    }
    /* eslint-disable-next-line compat/compat */
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '200px 0px 0px 0px',
    }).observe(this)
  }

  get baseUrl () {
    return this.dataset.baseUrl
  }

  get limit () {
    return this.dataset.limit
  }

  get productId () {
    return this.dataset.productId
  }

  get intent () {
    return this.dataset.intent
  }

  get sectionId () {
    return this.dataset.sectionId
  }
}

if (!customElements.get('bao-product-recommendations')) {
  customElements.define('bao-product-recommendations', BaoProductRecommendations)
}
